import { WhatsappIcon } from '@hugeicons/react'
import _ from 'lodash'

import { Button } from '@/shared/ui'
import { Badge } from '@/shared/ui/Badge'

import { whatsappHref } from './whatsapp'
import { partnerCategoryNames } from '../lib/partnerCategories'

/**
 * Non-premium partner profile (handoff #1d). No banner, catalog, tags or form —
 * only identity + direct WhatsApp contact. Navigation lives in the shell
 * `PageHeader`; rewards/check-in, when present, sits below the card.
 *
 * This is the DEFAULT profile branch (`Show.jsx:210`) — the premium cover is
 * the exception, not the rule. `requirements.md:109-112` asks that a partner
 * with two categories show both on the profile, so the labels belong here
 * first of all.
 */
export const PartnerBasicProfile = ({ partner, rewardsCheckIn }) => {
  const logoUrl = _.get(partner, 'logo.file.url')
  const whatsapp = whatsappHref(partner?.meta?.whatsapp)
  const categoryNames = partnerCategoryNames(partner?.partner_categories)

  return (
    <div className="pb-8">
      <div className="rounded-[20px] bg-white p-6 text-center shadow-[0_2px_10px_rgba(76,29,149,.07)]">
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={partner?.name}
            className="mx-auto h-[88px] w-[88px] rounded-3xl object-cover object-center"
          />
        ) : (
          <div className="mx-auto h-[88px] w-[88px] rounded-3xl bg-brand-light" />
        )}
        {/* Superfície de detalhe, e é ela que o requisito cobra: mostra
            todas, sem contador. O orçamento aqui não é o da listagem — o
            cartão é centralizado, sem logo lateral e sem rail:

              375 − 24 (Screen.Content `px-3`) − 48 (cartão `p-6`) = 303px

            Pílula = 20px de padding + ~7,5px por caractere, então
            "PATROCINADORES" (125px) e "CO-REALIZAÇÃO" (118px) somam 251px com
            o gap e cabem na mesma linha; a terceira quebra para a linha de
            baixo, que aqui não espreme nada.

            `tone="light"` e não `ghost`: é a forma que `PartnerTags.jsx` já
            usa para N rótulos nesta mesma feature, e N rótulos em tipografia
            solta correriam juntos sem separador. */}
        {categoryNames.length > 0 && (
          <div
            data-testid="partner-profile-categories"
            className="mt-3 flex flex-wrap justify-center gap-2"
          >
            {categoryNames.map(categoryName => (
              <Badge
                key={categoryName}
                variant="available"
                tone="light"
                size="sm"
                showIcon={false}
              >
                {categoryName}
              </Badge>
            ))}
          </div>
        )}

        <h1 className="m-0 mt-3.5 text-[22px] font-extrabold leading-tight text-gray-900">
          {partner?.name}
        </h1>
        {!!partner?.meta?.headline && (
          <p className="mx-auto mt-1.5 mb-0 text-sm leading-snug text-gray-700">
            {partner.meta.headline}
          </p>
        )}
        {whatsapp && (
          <Button
            href={whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            variant="whatsapp"
            size="lg"
            className="mt-5 w-full gap-2"
            leadingIcon={<WhatsappIcon size={18} variant="stroke" />}
            showTrailingIcon={false}
          >
            Falar no WhatsApp
          </Button>
        )}
      </div>

      {rewardsCheckIn && (
        <div className="mt-5 rounded-2xl bg-white p-4 shadow-[0_2px_10px_rgba(76,29,149,.07)]">
          {rewardsCheckIn}
        </div>
      )}
    </div>
  )
}
